import React from 'react';
import { Route } from 'react-router-dom';

const PrivateRoute = ({ children, token, userRoles, name, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return children;
      }}
    />
  );
};

export default PrivateRoute;
